import { Box, BoxProps } from '@cmpsr/components';
import { ReactNode } from 'react';

interface ContentContainerProps extends BoxProps {
  children: ReactNode;
}

export const ContentContainer = ({ children, ...rest }: ContentContainerProps) => {
  return (
    <Box
      display="flex"
      width={{ base: '100%', lg: '600px' }}
      paddingX={{ base: 'spacer-7', lg: 'spacer-0' }}
      flexDirection="column"
      alignItems="center"
      gap={{ base: 'spacer-8', lg: 'spacer-10' }}
      {...rest}
    >
      {children}
    </Box>
  );
};

export const ContentContainerV2 = ({ children, ...rest }: ContentContainerProps) => {
  return (
    <Box
      display="flex"
      width={{ base: '315px', md: '600px' }}
      flexDirection="column"
      alignItems="center"
      alignContent="center"
      {...rest}
    >
      {children}
    </Box>
  );
};

export default ContentContainer;
